<template>
  <el-dialog
    :close-on-click-modal="false"
    title="费率阶梯"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <el-table
        :data="tableData.data"
        tooltip-effect="dark"
      >
        <!-- 常规列表项 -->
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :sortable="item.sortable"
          :filters="item.filters"
          :filter-method="item.filterHandler"
          :min-width="item.minW"
          :width="item.w"
        />
      </el-table>
      <section class="tip">
        <el-alert
          :closable="false"
          title="温馨提示：发票费率根据税务政策可能会有波动，以申请开票所在月份的政策费率为准。"
          type="warning" />
      </section>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  invoiceApplyRate,
} from 'api/operate';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'amount',
            label: '开票金额',
          },
          {
            prop: 'rateValue',
            label: '费率（%）',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {

    /**
     * @param {String} tenantId 费率id
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (tenantId) {
      this.dialogFormVisible = true; // 打开弹窗
      const res = await invoiceApplyRate({
        tenantId,
      });
      this.tableData.data = res.rateItemList.map((item) => ({
        amount: `${item.startValue}${item.endValue ? '-' + item.endValue : '以上'}`,
        rateValue: item.rateValue + '%',
      }));
    },
  },
};
</script>

<style scoped lang="scss">
.tip{
  margin-top: 24px;
}
</style>
